import componentStyle from 'component/componentStyle'
import TextInput from 'component/field/TextInput'
import BoxFullWidth from 'component/material/BoxFullWidth'
import CustomTooltip from 'component/material/CustomTooltip'
import PrimaryButton from 'component/material/PrimaryButton'
import Table from 'component/material/table/Table'
import {isLoggedUser, redirectTo} from 'helper/functions'
import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import {getTermList} from 'redux/action/termsAction'
import {ReactComponent as Edit} from 'style/asset/edit.svg'
import {Trans} from '@lingui/macro'
import withStyles from '@material-ui/core/styles/withStyles'
import useTablePage from 'hooks/useTablePage'
import useTableSort from 'hooks/useTableSort'

let searchInterval = null

const TermsPage = (props) => {
  const {classes, rowsPerPage, getTermList, termList, termListLoading, termListMeta} = props

  const [tableSort, handleTableSort] = useTableSort({orderBy: 'fleet', orderDirection: 'ASC'})
  const [page, handleChangePage] = useTablePage()

  const [searchValue, setSearchValue] = useState(null)

  const openDetail = (row) => () => {
    redirectTo('/term/' + row.id)
  }

  const columns = [
    {
      name: 'id',
      sortKey: 'id',
      align: 'right',
      label: <Trans>ID</Trans>,
      width: '60px',
    },
    {
      name: 'fleet',
      sortKey: 'fleet',
      label: <Trans>Fleet</Trans>,
    },
    {
      name: 'type_of_work',
      sortKey: 'type_of_work',
      label: <Trans>Type of work</Trans>,
    },
    {
      name: 'price',
      sortKey: 'price',
      label: <Trans>Price</Trans>,
    },
    {
      name: 'unit',
      sortKey: 'unit',
      label: <Trans>Unit</Trans>,
    },
    {
      name: 'region',
      sortKey: 'region',
      label: <Trans>Region</Trans>,
    },
    {
      name: 'insured_event',
      sortKey: 'insured_event',
      label: <Trans>Insured event</Trans>,
      render: (val) => (val ? <Trans>true</Trans> : <Trans>false</Trans>),
    },
    {
      name: '',
      label: '',
      align: 'right',
      width: '40px',
      render: (val, row) => (
        <div className={classes.editIcon} onClick={openDetail(row)}>
          <Edit />
        </div>
      ),
    },
  ]

  const openNew = () => {
    redirectTo('/term/new')
  }

  const debounceSearch = (value) => {
    clearTimeout(searchInterval)
    searchInterval = setTimeout(() => {
      handleChangePage(0)
      setSearchValue(value)
    }, 500)
  }

  const handleSearchChange = (e) => {
    debounceSearch(e.target.value)
  }

  useEffect(() => {
    if (isLoggedUser()) {
      getTermList(rowsPerPage, page * rowsPerPage, tableSort, searchValue).catch(() => {})
    } else {
      redirectTo('/')
    }
    return () => {
      clearTimeout(searchInterval)
    }
  }, [page, rowsPerPage, tableSort, searchValue])

  return (
    <BoxFullWidth>
      <div className={classes.listPageControlContainer}>
        <div className={classes.searchContainer}>
          <div className={classes.searchLabel}>
            <Trans>Search:</Trans>
          </div>
          <TextInput
            onChange={handleSearchChange}
            loading={termListLoading}
            className={classes.searchInput}
            showHelperText={false}
          />
        </div>
        <div>
          <CustomTooltip title={<Trans>New term</Trans>}>
            <PrimaryButton
              fullWidth={false}
              textPadding={0}
              text={<Trans>Add</Trans>}
              onClick={openNew}
            />
          </CustomTooltip>
        </div>
      </div>
      <div className={classes.overFlowAuto}>
        <Table
          data={termList}
          columns={columns}
          loading={termListLoading}
          onTableColumnSort={handleTableSort}
          tableSort={tableSort}
          page={page}
          meta={termListMeta}
          onChangePage={handleChangePage}
        />
      </div>
    </BoxFullWidth>
  )
}

TermsPage.propTypes = {
  classes: PropTypes.object,
  rowsPerPage: PropTypes.number,
  getTermList: PropTypes.func,
  termList: PropTypes.array,
  termListLoading: PropTypes.bool,
  termListMeta: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getTermList,
    },
    dispatch
  )
}

export default compose(
  withStyles(componentStyle),
  connect((store) => {
    return {
      rowsPerPage: store.globalSettings.rowsPerPage,
      termList: store.term.termList,
      termListLoading: store.term.termListLoading,
      termListMeta: store.term.termListMeta,
    }
  }, mapDispatchToProps)
)(TermsPage)
